import { render, staticRenderFns } from "./ConfiguracionArticuloChild.vue?vue&type=template&id=6eda2a8e"
import script from "./ConfiguracionArticuloChild.vue?vue&type=script&lang=js"
export * from "./ConfiguracionArticuloChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports